module.exports = __webpack_public_path__ + "static/img/lisa.727c66ed.png";